// @flow

import removeEstimateItem from '../../../Services/removeEstimateItem';
import type { RemoveEstimateItemParams } from '../../../types';

export default (params: RemoveEstimateItemParams) => async (dispatch: Function) => dispatch(removeEstimateItem(params))